export const rpcs = {
  bsc: 'https://bsc-mainnet.nodereal.io/v1/aff09ffcae0a40ae80cd7fe3d1a9cf35',
  minato: 'https://soneium-minato.rpc.scs.startale.com?apikey=iFYLiG7ROGg2KSst6bS7gRBIPV7rNtei',
  optimism: 'https://opt-mainnet.nodereal.io/v1/aff09ffcae0a40ae80cd7fe3d1a9cf35',
  astar: 'https://evm.astar.network',
  minatoPublic: 'https://rpc.minato.soneium.org',
  shibuya: 'https://rpc.startale.com/shibuya?apikey=j0Hb3fH0xG5E4Xtm5ZgZd7Czda2nIjxh',
  testbnb: 'https://bsc-testnet.nodereal.io/v1/aff09ffcae0a40ae80cd7fe3d1a9cf35',
  testpolygon: 'https://polygon-amoy.infura.io/v3/7264e62271c24c22b31bc13bd3755d51',
  testpolygon1: 'https://rpc-amoy.polygon.technology',
  sepolia: 'https://eth-sepolia.nodereal.io/v1/aff09ffcae0a40ae80cd7fe3d1a9cf35',
  soneium: 'https://soneium.rpc.scs.startale.com?apikey=CBKpDfekGVM2CdVP8o1hCzjuDHgexAmR',
  local: 'http://localhost:8545',
}
export const cciprpc = {
  L1: rpcs.shibuya,
  L2: rpcs.minato,
}
